import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "xmlexportmaps"
    }}>{`XMLExportMaps`}</h1>
    <p>{`A collection of XML export maps.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`length`}</strong>{` `}</p>
      <p parentName="blockquote">{`The number of objects in the collection.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`add`}</strong>{`( Mixed `}<strong parentName="p">{`mappedStyle`}</strong>{`, Mixed `}<strong parentName="p">{`markupTag`}</strong>{`, Object `}<strong parentName="p">{`withProperties`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Create a new mapping`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`mappedStyle`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The mapped style. Can accept: ParagraphStyle, CharacterStyle, TableStyle, CellStyle or String.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`markupTag`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The tag to map. Can accept: XMLTag or String.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Object`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`withProperties`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Initial values for properties of the new XMLExportMap (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`count`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Displays the number of elements in the XMLExportMap.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`item`}</strong>{`( Mixed `}<strong parentName="p">{`index`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Returns the XMLExportMap with the specified index or name.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`index`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The index or name. Can accept: Long Integer or String.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`itemByRange`}</strong>{`( Mixed `}<strong parentName="p">{`from`}</strong>{`, Mixed `}<strong parentName="p">{`to`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Returns the XMLExportMaps within the specified range.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-2"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`from`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The XMLExportMap, index, or name at the beginning of the range. Can accept: XMLExportMap, Long Integer or String.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`to`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The XMLExportMap, index, or name at the end of the range. Can accept: XMLExportMap, Long Integer or String.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`firstItem`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Returns the first XMLExportMap in the collection.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`lastItem`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Returns the last XMLExportMap in the collection.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`middleItem`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Returns the middle XMLExportMap in the collection.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`previousItem`}</strong>{`( XMLExportMap `}<strong parentName="p">{`obj`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Returns the XMLExportMap with the index previous to the specified index.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-3"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`XMLExportMap`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`obj`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The index of the XMLExportMap that follows the desired XMLExportMap.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`nextItem`}</strong>{`( XMLExportMap `}<strong parentName="p">{`obj`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Returns the XMLExportMap whose index follows the specified XMLExportMap in the collection.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-4"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`XMLExportMap`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`obj`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The XMLExportMap whose index comes before the desired XMLExportMap.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`anyItem`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Returns any XMLExportMap in the collection.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`everyItem`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Returns every XMLExportMap in the collection.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the XMLExportMap.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportMap `}<strong parentName="p">{`[]`}</strong>{`( Number `}<strong parentName="p">{`index`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Returns the XMLExportMap with the specified index.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-5"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Number`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`index`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The index.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      